<script>
  import { InlineNotification, NotificationActionButton, OverflowMenu, OverflowMenuItem } from 'carbon-components-svelte';

  export let kind,
    title,
    subtitle,
    actions = [],
    extraActions = [],
    dismissible = false,
    onClose = () => {};
</script>

<InlineNotification
  class="custom-inline-notification"
  hideCloseButton={!dismissible}
  lowContrast
  {...{ kind, title, subtitle }}
  on:close={onClose}
>
  <div slot="actions" class="actions">
    {#if actions.length}
      {#each actions as { text, onClick, disabled }}
        <NotificationActionButton on:click={onClick} {disabled}>
          {text}
        </NotificationActionButton>
      {/each}
    {/if}
    {#if extraActions.length}
      <OverflowMenu flipped portalMenu size="sm">
        {#each extraActions as { text, onClick, disabled, danger }}
          <OverflowMenuItem {text} on:click={onClick} {disabled} {danger} />
        {/each}
      </OverflowMenu>
    {/if}
  </div>
</InlineNotification>

<style>
  .actions :global(button.bx--overflow-menu) {
    margin-bottom: 0.5rem;
  }

  @media (min-width: 42rem) {
    .actions :global(button.bx--overflow-menu) {
      margin-bottom: 0;
    }
  }
</style>
